@if (tabCoordinator.isSuperseded()) {
  <div class="amcf-tab-superseded" role="alertdialog" aria-modal="true" aria-labelledby="amcfTabSupersededTitle" aria-describedby="amcfTabSupersededDesc">
    <div class="amcf-tab-superseded__card">
      <h1 class="h5 mb-3" id="amcfTabSupersededTitle">Scheda non attiva</h1>
      <p class="mb-0" id="amcfTabSupersededDesc">{{ supersededTabMessage }}</p>
    </div>
  </div>
} @else {
  <app-toast-host />
  <app-connectivity-alert-modal />
  <router-outlet />
}
